<template>
  <v-container>
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ $t("fundBaseForm.title") }}
      </v-toolbar-title>
    </v-app-bar>

    <BaseForm :id="id" />
  </v-container>
</template>

<script>
import BaseForm from "@/components/User/Fund/BaseForm";

export default {
  components: {
    BaseForm,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },
};
</script>
